// Help titles, loaded with the page so every help button has its accessible name before the
// full content (qoeHelpContent.ts) is fetched. Generated from the same verified source; a test
// asserts these match QOE_HELP_CONTENT exactly.
import type { QoeHelpId } from './qoeHelpContent'

export const QOE_HELP_TITLES: Record<QoeHelpId, string> = {
  "workspace.lifecycle": "How to use the QoE workspace",
  "workspace.management_contribution": "Contributing as management",
  "workspace.engagement_selector": "Engagement selector",
  "workspace.new_engagement": "New engagement",
  "workspace.revision": "Revision",
  "workspace.synthetic_banner": "Synthetic demonstration banner",
  "workspace.view_access_banner": "View access",
  "workspace.reload_current_version": "Reload current version",
  "workspace.action_status": "Action progress and notices",
  "overview.tab": "Overview",
  "overview.hero": "Engagement summary",
  "overview.readiness": "Readiness: Blocked / Qualified / Ready For Review",
  "overview.metric.reported_ebitda": "Reported EBITDA",
  "overview.metric.normalized_ebitda": "Advisor normalized EBITDA",
  "overview.metric.source_reconciliation": "Source reconciliation",
  "overview.metric.open_findings": "Open findings",
  "overview.changes.sources": "What changed since the last version? — source rows",
  "overview.changes.issued_comparison": "Comparison with the last issued package",
  "overview.focus": "Where to focus",
  "overview.facts": "One source version, connected workpapers",
  "settings.form": "Engagement scope & materiality",
  "settings.name": "Engagement name",
  "settings.accounting_basis": "Accounting basis",
  "settings.materiality": "Materiality (USD)",
  "settings.historical_window": "Historical window (History from / through)",
  "settings.earnings_window": "Earnings window (Earnings from / through)",
  "settings.comparison_window": "Comparison window (Comparison from / through)",
  "settings.entities": "Included USD entities",
  "settings.entity_inclusion_dates": "Included from / Included through",
  "settings.elimination_entities": "Elimination entries",
  "settings.mapping_reviewed": "Account classifications reviewed",
  "settings.eliminations_reviewed": "Eliminations reviewed",
  "settings.save": "Save scope",
  "revenue.tab": "Revenue",
  "revenue.sales_schedule": "What makes revenue repeatable?",
  "revenue.dimensions": "Revenue dimensions",
  "revenue.current_comparative_change": "Current revenue, Comparative revenue, Change",
  "revenue.share_of_current": "Share of current",
  "revenue.margins": "Current cost and Gross profit",
  "revenue.cohorts": "Customer cohort: New / Lost / Retained Expansion / Retained Contraction / Retained Flat",
  "revenue.price_volume": "Price effect and Volume effect",
  "revenue.revenue_types": "Revenue Type view",
  "revenue.findings": "Revenue evidence & limitations",
  "data.workstream": "Data & evidence",
  "data.mapping.section": "Review the account mapping",
  "data.mapping.search": "Find an account",
  "data.mapping.status": "Mapping status: Reviewed / Needs Review",
  "data.mapping.provider_classification": "Provider classification",
  "data.mapping.qoe_classification": "QoE classification",
  "data.mapping.reviewed_checkbox": "Account classification review attestation",
  "data.mapping.save_capture": "Save mapping and capture accounting data",
  "data.capture.section": "Accounting source snapshot",
  "data.capture.action": "Capture connected accounting data",
  "data.import.section": "Import supporting schedules",
  "data.import.schedule_select": "CSV schedule",
  "data.import.source_file": "Source file",
  "data.import.replacement_rules": "Stable source ID and replacement",
  "data.import.sign_conventions": "Amount format and sign conventions",
  "data.schedule.ledger": "Ledger schedule",
  "data.schedule.trial_balance": "Trial balance schedule",
  "data.schedule.financial_statements": "Financial statements schedule",
  "data.schedule.sales": "Sales schedule",
  "data.schedule.bank": "Bank statement schedule",
  "data.schedule.cash_revenue_adjustments": "Cash revenue adjustments schedule",
  "data.schedule.cash_conversion_adjustments": "Cash conversion adjustments schedule",
  "data.import.json": "Replace with a complete JSON source set",
  "data.import.templates": "Download source templates",
  "data.coverage.section": "Coverage by entity and month",
  "data.coverage.status": "Coverage: Supplied / Incomplete",
  "data.controls.section": "Source control totals",
  "data.controls.status": "Control result: Reconciled / Difference / Unavailable",
  "data.controls.gl_to_tb_movement": "GL to TB movement",
  "data.controls.tb_rollforward": "TB roll-forward",
  "data.controls.tb_period_continuity": "TB period continuity",
  "data.controls.tb_to_financial_statement": "TB to financial statements",
  "data.controls.bank_rollforward": "Bank roll-forward",
  "data.controls.sales_to_ledger_revenue": "Sales to ledger revenue",
  "data.controls.ledger_equation": "Ledger balances (debits = credits)",
  "data.controls.trial_balance_equation": "Trial balance balances",
  "data.controls.source_control_total": "Source file control total",
  "data.evidence.section": "Evidence files",
  "data.evidence.upload": "Attach evidence file",
  "data.evidence.id": "Evidence ID",
  "data.evidence.download": "Document column: downloading an evidence file",
  "data.ledger.section": "Ledger evidence & transaction classifications",
  "data.ledger.cash_classification": "Cash classification",
  "data.ledger.posted_correction": "Correction already posted",
  "data.ledger.save": "Save transaction classifications",
  "data.provenance.section": "Source files & provenance",
  "data.demo.section": "Try a synthetic demonstration",
  "data.demo.load": "Load synthetic demonstration",
  "data.demo.banner": "Synthetic demonstration banner",
  "data.error.reload": "Reload current version",
  "earnings.tab": "Earnings",
  "earnings.bridge": "The earnings bridge",
  "earnings.bridge.kicker": "Reconciled historical earnings / Reported ledger earnings",
  "earnings.bridge.readiness": "Readiness: Blocked / Qualified / Ready For Review",
  "earnings.bridge.net_income": "Net income",
  "earnings.bridge.net_interest": "Net interest",
  "earnings.bridge.income_tax": "Income tax",
  "earnings.bridge.da": "Depreciation & amortization",
  "earnings.bridge.reported_ebitda": "Reported EBITDA",
  "earnings.bridge.accounting_corrections": "Accounting corrections",
  "earnings.bridge.corrected_ebitda": "Corrected EBITDA",
  "earnings.bridge.historical_normalizations": "Historical normalizations",
  "earnings.bridge.normalized_ebitda": "Normalized EBITDA",
  "earnings.bridge.pro_forma_adjustments": "Pro forma adjustments",
  "earnings.bridge.pro_forma_ebitda": "Pro forma EBITDA",
  "earnings.bridge.buyer_synergies": "Buyer synergies",
  "earnings.bridge.unavailable": "Earnings unavailable",
  "earnings.cases": "Compare the earnings cases",
  "earnings.cases.management": "Management original proposals",
  "earnings.cases.advisor": "Advisor accepted earnings",
  "earnings.cases.buyer": "Buyer scenario including accepted synergies",
  "earnings.monthly": "Monthly earnings",
  "earnings.monthly.unavailable": "Unavailable month",
  "earnings.ledger": "Adjustment ledger",
  "earnings.ledger.classification": "Adjustment and classification",
  "earnings.ledger.monthly_proposal": "Monthly proposal",
  "earnings.ledger.accepted_amounts": "Accepted amounts / Not accepted / Prior review — pending renewal",
  "earnings.ledger.review_status": "Review status",
  "earnings.ledger.support": "Support",
  "earnings.ledger.open_review": "Review proposed adjustments →",
  "earnings.form": "Propose an earnings adjustment",
  "earnings.form.title": "Adjustment title",
  "earnings.form.entity": "Entity",
  "earnings.form.category": "Adjustment category",
  "earnings.form.category.timing": "Timing adjustment",
  "earnings.form.proposed_by": "Proposed by",
  "earnings.form.monthly_amounts": "Month and signed amount",
  "earnings.form.owner_comp": "Actual owner cost and market replacement cost",
  "earnings.form.rationale": "Rationale",
  "earnings.form.evidence_ids": "Evidence IDs",
  "earnings.form.source_row_ids": "Source row IDs",
  "earnings.form.linked_items": "Linked NWC / debt item IDs",
  "earnings.form.save": "Save proposal for review",
  "earnings.finding.evidence_missing": "Accepted adjustment lacks evidence (material / not material)",
  "earnings.finding.accepted_amount_missing": "Accepted adjustment has no accepted monthly amounts",
  "earnings.finding.overlapping": "Source row allocated to multiple adjustments",
  "earnings.finding.already_posted": "Adjustment already posted in the books",
  "earnings.finding.stale_reference": "Draft adjustment has stale references",
  "earnings.finding.window_and_basis": "Earnings window, mapping and basis warnings",
  "cash.workstream": "Cash",
  "cash.proof": "Proof of cash",
  "cash.proof.book": "Book opening, receipts, disbursements and closing",
  "cash.proof.differences": "Opening, receipts, disbursements and closing differences (Δ)",
  "cash.proof.result": "Proof of cash result: Reconciled / Difference / Unavailable",
  "cash.revenue_bridge": "Customer receipts to revenue",
  "cash.revenue_bridge.receipts_revenue": "Customer receipts, revenue and difference",
  "cash.revenue_bridge.adjustments": "Bridge adjustments (receipts to revenue)",
  "cash.revenue_bridge.result": "Receipts-to-revenue result: Reconciled / Difference / Unavailable",
  "cash.conversion": "EBITDA to operating cash and capex",
  "cash.conversion.reported_ebitda": "Reported EBITDA (cash conversion)",
  "cash.conversion.interest_tax": "Less: net interest / Less: tax",
  "cash.conversion.nwc_change": "Less: increase in NWC",
  "cash.conversion.other_items": "Add: other bridge items",
  "cash.conversion.expected_recorded": "Expected vs recorded operating cash",
  "cash.conversion.unexplained": "Unexplained Δ (cash conversion)",
  "cash.conversion.capex": "Maintenance capex, growth capex and cash after capex",
  "cash.conversion.result": "Cash conversion result: Reconciled / Difference / Unavailable",
  "cash.findings": "Cash evidence & limitations",
  "cash.classifications": "Cash classification",
  "transaction.workstream": "NWC & debt",
  "transaction.equity_bridge_card": "Working capital & the equity bridge",
  "nwc.metric.selected_peg": "Selected NWC peg",
  "nwc.metric.closing_nwc": "Closing NWC",
  "nwc.metric.closing_true_up": "Closing true-up",
  "valuation.metric.equity_value": "Illustrative equity value",
  "valuation.status": "Valuation status",
  "nwc.monthly": "Normalized working capital",
  "nwc.monthly.complete": "NWC month: Yes / Incomplete",
  "valuation.bridge": "Enterprise value to equity",
  "valuation.bridge.enterprise_value": "Enterprise value",
  "valuation.closing_register": "Closing items (saved register)",
  "nwc.peg_alternatives": "Peg alternatives",
  "nwc.peg_alternatives.coverage": "Peg coverage: Available / Insufficient coverage / Not selected",
  "transaction.define": "Define the transaction",
  "valuation.multiple": "EBITDA multiple",
  "nwc.closing_month": "Closing month",
  "nwc.accounts": "Included NWC accounts by entity",
  "nwc.peg_method": "NWC peg method",
  "nwc.peg_months": "Peg months",
  "nwc.custom_peg": "Custom peg (USD)",
  "nwc.peg_rationale": "Peg rationale",
  "nwc.adjustments": "Monthly NWC adjustments",
  "nwc.adjustments.signed_effect": "Signed NWC effect (USD)",
  "debt.eligible_cash": "Eligible cash",
  "debt.financial_debt": "Financial debt",
  "debt.debt_like": "Debt-like items",
  "debt.other_equity": "Other equity adjustments",
  "debt.item_amount": "Closing item label, entity and amount",
  "debt.item_account_code": "Closing item account code and overlap errors",
  "debt.item_support": "Closing item rationale, evidence and Item ID",
  "transaction.save": "Save transaction assumptions",
  "transaction.findings": "Transaction findings",
  "review.tab": "Review",
  "review.desk": "Resolve the evidence behind the conclusion",
  "review.findings_severity": "Finding severity (Error / Warning)",
  "review.adjustment_card": "Review an earnings adjustment",
  "review.adjustment_origin": "Adjustment column: entity and proposer (Advisor / Management / Buyer / AI)",
  "review.adjustment_classification": "Classification",
  "review.adjustment_amount_columns": "Monthly proposal and Accepted amounts",
  "review.adjustment_support": "Support",
  "review.pending_renewal": "Prior review — pending renewal",
  "review.status_vocabulary": "Adjustment review status",
  "review.adjustment_select": "Adjustment to review",
  "review.disposition": "Review disposition",
  "review.accepted_monthly_effect": "Accepted monthly effect",
  "review.reviewer_rationale": "Reviewer rationale",
  "review.record_decision": "Record review decision",
  "review.refresh_count": "Adjustments requiring renewed review",
  "review.requests_card": "Evidence requests",
  "review.request_status": "Request status",
  "review.request_title": "Request title",
  "review.request_workstream": "Workstream",
  "review.request_documents": "Linked document IDs",
  "review.request_response": "Response and review notes",
  "review.request_save": "Save evidence request",
  "review.request_update": "Update request / Start another request",
  "review.signoff_card": "Separate review of revision N",
  "review.signoff_eligibility": "Who can sign the separate review",
  "review.signoff_qualifications": "Package qualifications for separate review",
  "review.signoff_acknowledgement": "Separate reviewer acknowledgement",
  "review.signoff_record": "Record separate review",
  "review.signoff_table": "Recorded separate reviews",
  "review.separately_reviewed_label": "Separately reviewed — second reviewer required",
  "review.solo_path": "Advisor prepared — solo preparation",
  "review.activity": "Engagement activity",
  "review.revision_conflict": "Engagement changed in another session",
  "review.view_access": "View access",
  "deliverables.tab": "Deliverables",
  "deliverables.issue": "Issue the diligence package",
  "deliverables.issue.blocked": "Issuance blocked",
  "deliverables.issue.unresolved_findings": "Unresolved findings or qualifications",
  "deliverables.outputs.excel": "Excel workpapers",
  "deliverables.outputs.pdf": "PDF report",
  "deliverables.outputs.evidence_json": "Evidence package (JSON)",
  "deliverables.issue.label": "Package review label",
  "deliverables.issue.qualifications": "Package qualifications",
  "deliverables.issue.acknowledgement": "Issuance acknowledgement",
  "deliverables.issue.submit": "Issue revision",
  "deliverables.packages": "Issued packages",
  "deliverables.packages.label_status": "Advisor Prepared / Separately Reviewed",
  "deliverables.packages.download_excel": "Download Excel",
  "deliverables.packages.download_pdf": "Download PDF",
  "deliverables.packages.evidence_json": "Evidence JSON",
  "deliverables.sharing": "Verify files & share this issued package",
  "deliverables.sharing.verification_status": "File verification pending / Issued files verified",
  "deliverables.sharing.prepare": "Prepare stored files for verification",
  "deliverables.sharing.stored_files": "Stored files to verify",
  "deliverables.sharing.workbook_bundle": "Complete workbook and source bundle",
  "deliverables.verify.checks": "Verification statements",
  "deliverables.verify.acknowledgement": "File verification acknowledgement",
  "deliverables.verify.submit": "Record verification of these exact files",
  "deliverables.share.recipient_access": "Recipient access",
  "deliverables.share.email": "Recipient email",
  "deliverables.share.expiry": "Access expires",
  "deliverables.share.grant": "Grant access to verified files",
  "deliverables.share.link": "Recipient package page link",
  "deliverables.share.access_status": "Access: Active / Expired / Revoked",
  "deliverables.share.revoke": "Revoke access",
  "deliverables.proposal_import": "Import proposed adjustments from Excel",
  "deliverables.proposal_import.apply": "Import proposed adjustments",
  "recipient.page": "Issued diligence package (recipient view)",
  "recipient.sign_in": "Sign in to view package",
  "recipient.errors": "Checking access / package errors",
  "recipient.access_notice": "Issued version and access limits",
  "recipient.verified": "Issued files verified",
  "recipient.qualifications": "Scope qualifications",
  "recipient.files": "Issued files",
  "recipient.issuance_record": "Issuance record",
}

export const QOE_HELP_IDS = Object.keys(QOE_HELP_TITLES) as QoeHelpId[]
